<div class="users-container">
    <app-form-row>
      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Appointments'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{appointmentCount}}</label>
          </div>
        </div>
      </app-card-sm-container>
    </app-form-row>

    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Doctors Contact Number'">
        </app-label>
        <app-textbox
            [maxLength]="10"
            [minLength]="10"
            [control]="doctorIDControl">
        </app-textbox>
    </app-form-row>

    <app-button [button]="createAppointmentButton">
    </app-button>
</div>
